import { render, staticRenderFns } from "./MsArticleList.vue?vue&type=template&id=3168d23f&scoped=true&"
import script from "./MsArticleList.vue?vue&type=script&lang=js&"
export * from "./MsArticleList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3168d23f",
  null
  
)

export default component.exports